module.exports = __webpack_public_path__ + "static/media/clone.62f2107e.svg";